import Form from "@/components/Shared/Form";
import clsx from "classnames";
import PropTypes from "prop-types";
import { Container } from "reactstrap";
import styles from "./styles.module.scss";
import { useEffect, useState } from 'react';

export default function DefaultPageTemplate({
  className,
  global,
  pathPrefix,
  post,
  successPageUrl,
}) {

  const [scriptLoaded, setScriptLoaded] = useState(false);
  const isFileClearedFeedback = post?.url_slug === 'file-cleared-feedback';

  useEffect(() => {
    if (isFileClearedFeedback && post?.hubspot_from) {
      const scriptMatch = post.hubspot_from.match(/<script\s+src=["']?([^"'>]+)["']?\s*defer?><\/script>/i);
      if (scriptMatch && scriptMatch[1]) {
        const scriptSrc = scriptMatch[1];
        if (!document.querySelector(`script[src="${scriptSrc}"]`)) {
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.defer = true;
          script.onload = () => setScriptLoaded(true);
          document.body.appendChild(script);
        } else {
          setScriptLoaded(true);
        }
      }
    }
  }, [post, isFileClearedFeedback]);

  const divMatch = post?.hubspot_from?.match(/(<div class=["']hs-form-frame["'][\s\S]*?<\/div>)/i);
  const formDivHtml = divMatch ? divMatch[1] : null;

  return (
    <>
      <section className={clsx(className, styles.root)}>
        <Container>
          {post.content && (
            <div className={styles.content} dangerouslySetInnerHTML={{ __html: post.content }} />
          )}
          {post?.form && (
            <Form className={`mt-5`} formId={post?.form} successPageUrl={successPageUrl} />
          )}
            {formDivHtml && scriptLoaded && (
        <div
          className="mt-5"
          dangerouslySetInnerHTML={{ __html: formDivHtml }}
        />
      )}

          
        </Container>
      </section>
    </>
  );
}

DefaultPageTemplate.defaultProps = {
  pathPrefix: "",
  className: "py-5",
  successPageUrl: "/submission-success",
};

DefaultPageTemplate.propTypes = {
  pathPrefix: PropTypes.string,
  className: PropTypes.string,
  successPageUrl: PropTypes.string,
};
